module.exports = __webpack_public_path__ + "static/media/BUSM.277a944d.png";